import { Box } from '@mui/material';
import MediaEntetiesTable from '../../../common/MediaEntitiesTable';

const InfluenceralTable = () => {
	return (
		<Box className="w-full">
			<MediaEntetiesTable media_id={11} />
		</Box>
	);
};

export default InfluenceralTable;
